import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { filter, take, map } from 'rxjs/operators';
import { IBrowserInfoHeaders } from '../browser-manager.data';
import {
  getBrowserInfoHeaders,
  getDevice,
  getDeviceId,
  getPlatform,
  isFirefox,
  isIE,
  isMacOS,
  isMobile,
  isOnline,
  isTablet,
} from '../reducers';
import { combineLatest } from 'rxjs';

@Injectable()
export class BrowserManagerStore {
  deviceId$: Observable<string> = this._store.pipe(select(getDeviceId));

  constructor(private _store: Store<any>) {}

  getDeviceId(): Observable<string> {
    return this.deviceId$.pipe(
      filter((x) => !!x),
      take(1)
    );
  }

  isMobile(): Observable<boolean> {
    return this._store.pipe(select(isMobile), take(1));
  }

  isTablet(): Observable<boolean> {
    return this._store.pipe(select(isTablet), take(1));
  }

  isWeb(): Observable<boolean> {
    return combineLatest(this.isMobile(), this.isTablet()).pipe(
      map(
        ([isMobileDevice, isTabletDevice]: [boolean, boolean]) =>
          !isMobileDevice && !isTabletDevice
      )
    );
  }

  isMacOS(): Observable<boolean> {
    return this._store.pipe(select(isMacOS), take(1));
  }

  getDevice(): Observable<string> {
    return this._store.pipe(select(getDevice), take(1));
  }

  getPlatform(): Observable<string> {
    return this._store.pipe(select(getPlatform), take(1));
  }

  isIE(): Observable<boolean> {
    return this._store.pipe(select(isIE), take(1));
  }

  isFirefox(): Observable<boolean> {
    return this._store.pipe(select(isFirefox), take(1));
  }

  isOnline(): Observable<boolean> {
    return this._store.pipe(select(isOnline), take(1));
  }

  getBrowserInfoHeaders(): Observable<IBrowserInfoHeaders> {
    return this._store.pipe(select(getBrowserInfoHeaders));
  }
}
